import React, { useState, useEffect } from 'react'
import { TextInputField, Text, Switch, Pane } from 'evergreen-ui'
import BtnDefault from './BtnDefault'
const EditForm = ({
  user, edit, invite, showEdit, showTimeClock, showDocID
}) => {
  const [employee, setEmployee] = useState({
    name: '',
    active: true,
    usesTimeClock: false,
    document: '',
  })

  useEffect(() => {
    setEmployee(user)
  }, [user])

  const handleChange = ({ target }) => setEmployee({ ...employee, [target.name]: target.value })

  return (
    <form onSubmit={(e) => {
      e.preventDefault()
      edit(employee)
    }} >
      <TextInputField
        label='Nome'
        description=""
        name='name'
        placeholder='Nome'
        value={employee.name} onChange={handleChange} />
        { showDocID && <>
          <TextInputField
            label='Documento Identificador'
            description=""
            name='document'
            placeholder='Identificador'
            value={employee.document} onChange={handleChange} />
            </>
        }
      <Pane flex={1} display="flex">
        <Pane width="100">
          <Text>
            Ativo
          </Text>
          <Switch
              name='active'
              height={24}
              checked={employee.active}
              onChange={({ target }) => {
                setEmployee({ ...employee, [target.name]: target.checked })
              }}
              marginBottom={16}
            />
        </Pane>
          { showTimeClock && <>
            <Pane width="100">
              <Text marginLeft={15}>Solicita Registro Ponto</Text>
              <Switch
                name='usesTimeClock'
                height={24}
                checked={employee.usesTimeClock}
                onChange={({ target }) => {
                  setEmployee({ ...employee, [target.name]: target.checked })
                }}
                marginBottom={16}
                marginLeft={15}
              />
            </Pane>
          </>
          }
      </Pane>
      <BtnDefault
        type='submit'
        disabled={!employee.name.length > 0}
        appearance='primary'> Editar </BtnDefault>

      { showEdit &&
      <BtnDefault
        style={{
          marginLeft: 20
        }}
        type='button'
        disabled={!employee.email}
        onClick={() => {
          edit(employee)
          invite() }}
        appearance='primary' icon='envelope'> Enviar </BtnDefault>
      }
    </form>
  )
}

export default EditForm